/**
 * When the application (ERP) can be installed, and what comes before it. The one place to change the wording and the steps.
 *
 *   No new environment (the RDS server and the DB server are both Existing): nothing is built, so the application can be installed right away.
 *   A new environment (either server is Dedicated): the application is installed after the environment is built and set up.
 *
 * The steps before the install are the ones New-TraverseEnvironment.ps1 does after the infrastructure exists (Active Directory groups, the
 * client folder, RemoteApps, SQL child scripts, run once the host is domain-joined). [CONFIRM the list with the application team]
 */
export type InstallTiming = 'immediately' | 'after_new_environment'

export const IMMEDIATE_INSTALL_NOTE = 'No new environment is being created, so the application can be installed right away.'
export const NEW_ENVIRONMENT_NOTE = 'A new environment is being created, so the application is installed after these steps:'

export const DOMAIN_JOIN_STEP = 'The new RDS server joins the domain.'
export const TRAVERSE_CONFIGURE_STEP = 'Traverse is set up on the new environment: Active Directory groups, the client folder and RemoteApps, and the SQL child scripts.'
export const INSTALL_STEP = 'The application is installed.'

export const builtServerStep = (kind: string, name: string): string => (name ? `The new ${kind} ${name} is built.` : `The new ${kind} is built.`)
export const sqlInstanceStep = (name: string): string => `The SQL instance ${name} is created.`

/** Asked in a production environment only: a production environment holds the customer's Production and its Sandbox. */
export const CREATE_FOR_QUESTION = 'Is the application being created for Production or Sandbox?'
export const CREATE_FOR_HINT = 'This is a production environment, so it can hold either. It decides the Product ID (the Production key or the Sandbox key) and the script’s EnvType.'

